import { savedOrderDetailsCartLineStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsCartLine";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { isMgbwWebsite } from "@tSurya/Common/Utilities/websiteUtils";
import { COLORS as SURYA_COLORS } from "@tSurya/theme/design.surya";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

// MGBW: Surya buttons have no hover effect. Pin the outline button's
// hover/active/focus state to its rest colors so MGBW matches Surya.
// Render-time brand check (SSR-safe); no-op for Surya / Global Views.
const mgbwSavedOrderAddToProjectTextColor = "#545454";

// GridItem keeps its screen `max-width`/`flex-basis` in print, so `printWidth` alone cannot widen
// a column. These helpers restate the width for print and undo the grid's `word-break: break-all`.
const printColumnWidth = (value: string) => css`
    width: ${value};
    max-width: ${value};
    flex-basis: ${value};
    word-break: normal;
`;

const printPartNumberRow = css`
    @media print {
        display: flex;
        flex-direction: row;
        align-items: baseline;
        width: 100%;
        max-width: 100%;
        word-break: normal;
    }
`;

const mgbwOutlineButtonNoHover = css`
    ${() =>
        isMgbwWebsite()
            ? css`
                  color: ${mgbwSavedOrderAddToProjectTextColor} !important;
                  span[class^="TypographyStyle"],
                  svg {
                      color: ${mgbwSavedOrderAddToProjectTextColor} !important;
                      fill: ${mgbwSavedOrderAddToProjectTextColor} !important;
                  }

                  &:not(:disabled):hover,
                  &:active,
                  &:focus {
                      color: ${mgbwSavedOrderAddToProjectTextColor} !important;
                      border-color: ${SURYA_COLORS.black} !important;
                      background: transparent !important;
                      span[class^="TypographyStyle"] {
                          color: ${mgbwSavedOrderAddToProjectTextColor} !important;
                      }
                      svg {
                          color: ${mgbwSavedOrderAddToProjectTextColor} !important;
                          fill: ${mgbwSavedOrderAddToProjectTextColor} !important;
                      }
                  }
              `
            : null}
`;

savedOrderDetailsCartLineStyles.savedOrderLineCardAddToListButton = {
    variant: "secondary",
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 5px;
        border: 1px solid ${COLORS.black} !important;
        ${mgbwOutlineButtonNoHover}
        /* border-radius: 0;
        padding: 10px 34px;
        background: ${getColor("primary")};
        border: 2px solid ${getColor("primary")};
        span[class^="TypographyStyle"] {
            color: ${getColor("common.background")};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        } */
        /* &:hover {
            background: ${getColor("text.accent")};
            border: 2px solid  background: ${getColor("text.accent")};
            span[class^="TypographyStyle"] {
                color: ${getColor("common.background")};
            }
        } */
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    padding: 0px 10px;
                `,
                null,
                null,
                null,
                null,
            ])}
    `,
};
savedOrderDetailsCartLineStyles.productDescription = {
    productDetailLink: {
        css: css`
            width: 100%;
            color: ${COLORS.text.main};
            font-weight: ${TYPOGRAPHY.weight.baseBold};
            text-decoration: none;

            span[class^="TypographyStyle"] {
                color: ${COLORS.text.main};
                font-weight: ${TYPOGRAPHY.weight.baseBold};
            }

            &:hover {
                color: ${COLORS.text.main};
                text-decoration: underline;
            }
        `,
    },
};

savedOrderDetailsCartLineStyles.productBrandAndDescriptionGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
        padding-bottom: 0;
    `,
};

savedOrderDetailsCartLineStyles.productPartNumbersGridItem = {
    width: 12,
    css: css`
        padding-top: 0;
    `,
};
savedOrderDetailsCartLineStyles.productPartNumbers = {
    // GridItem collapses to `display: block` in print, which drops the flex row and lets the
    // label run into the value. Force the row back and keep the SKU on its own line.
    erpNumberGridItem: {
        css: printPartNumberRow,
    },
    customerNameGridItem: {
        css: printPartNumberRow,
    },
    manufacturerItemGridItem: {
        css: printPartNumberRow,
    },
    erpNumberLabelText: {
        css: css`
            color: ${getColor("text.main")};

            @media print {
                margin-right: 4px;
                white-space: nowrap;
            }
        `,
    },
    erpNumberValueText: {
        css: css`
            color: ${getColor("text.main")};

            @media print {
                word-break: normal;
                overflow-wrap: anywhere;
            }
        `,
    },
};
savedOrderDetailsCartLineStyles.productPrice = {
    wrapper: {
        css: css`
            align-items: flex-end;
            text-align: right;
        `,
    },
    priceWrapper: {
        css: css`
            text-align: right;
        `,
    },
    priceLabelText: {
        css: css`
            font-size: 14px;
            text-transform: capitalize;

            @media print {
                font-size: 12px;
                white-space: nowrap;
            }
        `,
    },
    price: {
        priceText: {
            weight: "normal",
            css: css`
                color: ${getColor("text.main")};

                @media print {
                    white-space: nowrap;
                    word-break: normal;
                }
            `,
        },
    },
};

savedOrderDetailsCartLineStyles.subtotalWithoutVatText = {
    wrapper: {
        css: css`
            margin-bottom: 6px;
        `,
    },

    heading: {
        css: css`
            text-transform: capitalize;
            font-size: 14px;
        `,
    },
};

savedOrderDetailsCartLineStyles.vatAmount = {};

savedOrderDetailsCartLineStyles.extendedUnitNetPrice = {
    text: {
        weight: 700,
    },

    heading: {
        css: css`
            text-transform: capitalize;
            font-size: 14px;
        `,
        weight: 700,
    },
};

savedOrderDetailsCartLineStyles.productPriceAndQuantityGridItem = {
    width: [12, 12, 7, 7, 7],
    printWidth: 7,
};

savedOrderDetailsCartLineStyles.savedOrderLineCardAddToListGridItem = {
    width: [12, 12, 12, 4, 4],
    printWidth: 0,
    css: css`
        @media print {
            display: none !important;
        }

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    justify-content: flex-end;
                `,
                css`
                    justify-content: flex-end;
                `,
                css`
                    justify-content: flex-end;
                `,
                null,
                null,
            ])}
    `,
};

savedOrderDetailsCartLineStyles.priceGridItem = {
    width: [4, 4, 4, 3, 3],
    printWidth: 4,
    css: css`
        flex-direction: column;

        @media print {
            ${printColumnWidth("33.33%")}
        }
    `,
};

savedOrderDetailsCartLineStyles.quantityGridItem = {
    width: [4, 4, 4, 2, 2],
    printWidth: 4,
    css: css`
        text-align: center;

        @media print {
            ${printColumnWidth("33.33%")}
        }
    `,
};

savedOrderDetailsCartLineStyles.extendedUnitNetPriceGridItem = {
    width: [4, 4, 4, 3, 3],
    printWidth: 4,
    css: css`
        flex-direction: column;
        text-align: right;

        @media print {
            ${printColumnWidth("33.33%")}
        }
    `,
};
savedOrderDetailsCartLineStyles.extendedUnitNetPrice = {
    text: {
        weight: 700,
        css: css`
            @media print {
                white-space: nowrap;
                word-break: normal;
            }
        `,
    },
    heading: {
        css: css`
            text-transform: capitalize;
            font-weight: 700;
            font-size: 14px;
            @media print {
                font-size: 12px;
                font-weight: 700;
                white-space: nowrap;
            }
        `,
    },
};

savedOrderDetailsCartLineStyles.cartLineQuantity = {
    readOnlyQuantityText: {
        extendedStyles: {
            heading: {
                css: css`
                    font-size: 14px;
                    white-space: nowrap;
                    text-transform: capitalize;

                    @media print {
                        font-size: 12px;
                    }
                `,
            },
        },
    },
};
